import type { PropsWithChildren } from "react";

import { Button } from "#components/Button";
import { SupportMenu } from "#components/SupportMenu";
import { FilesIcon } from "#icons";

export interface AppHeaderProps extends PropsWithChildren {
  supportEnabled?: boolean;
  username?: string;
  email?: string;
  docsUrl?: string;
}

export function AppHeader({
  supportEnabled = false,
  username,
  email,
  docsUrl,
  children,
}: AppHeaderProps) {
  function openDocs() {
    window.open(docsUrl, "_blank");
  }

  const hasSupport = supportEnabled;

  return (
    <div className="flex h-[3rem] w-full items-center justify-between gap-3 rounded-xl bg-overlay-medium px-xl py-md shadow">
      <span className="text-page-headline font-semibold text-text-primary">{children}</span>
      <div className="flex items-center justify-end gap-1">
        {hasSupport ? <SupportMenu userEmail={email || ""} userName={username || ""} /> : null}

        {docsUrl ? (
          <Button
            aria-controls="menu-appbar"
            aria-haspopup="true"
            aria-label="documentation"
            className="hover:bg-transparent hover:text-brand-primary focus:bg-transparent focus:text-neutral-700"
            onPress={openDocs}
            variant="tertiary"
          >
            <FilesIcon className="size-lg" />
          </Button>
        ) : null}
      </div>
    </div>
  );
}
